export default {
  title: 'Tablero de Tire Rack',
  info: 'Cada columna muestra las reclamaciones de Tire Rack creadas en ese mes, según su estado actual, por lo que los meses recientes cambian a medida que se cierran las reclamaciones. Pagadas %, Denegadas % y CWOP % son porcentajes de las reclamaciones procesadas (cerradas, sin incluir las canceladas). Los tiempos de ciclo son días completos desde la creación de la reclamación hasta el pago o la denegación. Un guion significa que no hay datos o nada que medir, no cero.',
  notAvailable: 'El Tablero de Tire Rack solo está disponible para cuentas de Tire Rack.',
  loading: 'Cargando el Tablero de Tire Rack…',
  noData: 'No se devolvieron datos para este rango de fechas.',
  retry: 'Reintentar',
  error: {
    failed: 'No se pudo cargar el Tablero de Tire Rack. Inténtelo de nuevo.',
    forbidden: 'No tiene permiso para ver este informe.',
  },
  range: {
    label: 'Rango de fechas',
    last3Months: 'Últimos 3 meses',
    last6Months: 'Últimos 6 meses',
    last12Months: 'Últimos 12 meses',
    yearToDate: 'Año hasta la fecha',
    custom: 'Personalizado',
    startMonth: 'Mes inicial',
    endMonth: 'Mes final',
    apply: 'Aplicar',
    invalid: 'Elija un mes inicial igual o anterior al mes final, con un máximo de 120 meses.',
  },
  cwop: {
    title: 'Causa raíz de CWOP',
    caption: 'Cantidad (porcentaje del CWOP del mes). Una reclamación se cierra sin pago después de 31 días sin un documento nuevo, por lo que los últimos uno o dos meses aún se están completando.',
    noInstallation: 'No se recibió la documentación de instalación',
    noPurchase: 'No se recibió la documentación de compra del reemplazo',
    noDocumentation: 'No se recibió la documentación de reemplazo ni de instalación',
    other: 'Otro / no determinado',
  },
  metrics: {
    title: 'Métrica',
    caption: 'Reclamaciones agrupadas por mes de creación (UTC), según su estado actual.',
    created: 'Reclamaciones creadas',
    paid: 'Reclamaciones pagadas',
    denied: 'Reclamaciones denegadas',
    pending: 'Reclamaciones pendientes',
    cwop: 'Reclamaciones CWOP',
    paidPercent: 'Pagadas %',
    deniedPercent: 'Denegadas %',
    cwopPercent: 'CWOP %',
  },
  cycle: {
    title: 'Ciclo promedio de reclamación',
    average: 'Tiempo promedio del ciclo de reclamación (días promedio desde la apertura hasta el cierre)',
    repair: 'Reparación',
    replace: 'Reemplazo',
    within5Days: '% resueltas en 5 días',
  },
  dash: {
    unavailable: 'No disponible',
    noProcessedClaims: 'No hay reclamaciones procesadas',
    noResolvedClaims: 'No hay reclamaciones pagadas o denegadas',
    noQualifyingClaims: 'No hay reclamaciones resueltas que apliquen',
  },
};
